import { f as formatMoney } from "./currency-DRNmrEpZ.js";
import { C as Cart } from "./cart-DY-kXn0p.js";
import "./utils-D8tYCXRD.js";
import "./replacePersonalCansSection-BoLk9oIv.js";
class CartUpsell extends Cart {
  constructor() {
    super();
    this.productWrapper = void 0;
    this._recommendations = [];
    this.recommendationProductHandle = this.getAttribute(
      "data-recommendation-product-id"
    );
    this.recommendationsType = "related";
    this.recommendationsCount = 3;
  }
  connectedCallback() {
    this.cacheDomElements();
    super.connectedCallback();
    if (!this.productWrapper || !this.recommendationProductHandle) {
      return;
    }
    this.setEventListeners();
    this.fetchRecommendations();
  }
  cacheDomElements() {
    this.productWrapper = this.querySelector(
      '[js-cart-upsell="productWrapper"]'
    );
  }
  setEventListeners() {
    document.addEventListener(
      "cart-item:removed",
      () => this.fetchRecommendations()
    );
  }
  /**
   * Fetch products from metafield related_products first, then fall back to recommendations API
   */
  async fetchRecommendations() {
    try {
      const metafieldProducts = await this.fetchMetafieldRelatedProducts();
      if (metafieldProducts && metafieldProducts.length > 0) {
        this.recommendations = metafieldProducts;
        const showUpsell = this.recommendations && this.recommendations.length > 0;
        showUpsell ? this.showUpsell() : this.hideUpsell();
        return;
      }
      await this.fetchRecommendationsAPI();
    } catch (e) {
      console.error("Fetch error:", e);
      this.hideUpsell();
    }
  }
  /**
   * Fetch related products from metafields
   */
  async fetchMetafieldRelatedProducts() {
    var _a, _b, _c;
    if (!this.recommendationProductHandle)
      return null;
    try {
      const productUrl = `/products/${this.recommendationProductHandle}.js`;
      const response = await fetch(productUrl);
      if (!response.ok) {
        console.log(
          `Product URL ${productUrl} not found, falling back to recommendations API`
        );
        return null;
      }
      const productData = await response.json();
      const parentHandleMetafield = (_a = productData.metafields) == null ? void 0 : _a.find(
        (metafield) => metafield.namespace === "brewdog" && metafield.key === "parent_product_handle"
      );
      let recommendationSourceHandle = this.recommendationProductHandle;
      if (parentHandleMetafield == null ? void 0 : parentHandleMetafield.value) {
        const cleanParentHandle = parentHandleMetafield.value.replace(/^\/products\//, "").replace(/^\//, "");
        recommendationSourceHandle = cleanParentHandle;
        const parentProductUrl = `/products/${cleanParentHandle}.js`;
        const parentResponse = await fetch(parentProductUrl);
        if (parentResponse.ok) {
          const parentProductData = await parentResponse.json();
          productData.metafields = parentProductData.metafields;
          console.log(
            `Using parent product ${cleanParentHandle} for recommendations instead of ${this.recommendationProductHandle}`
          );
        } else {
          console.log(
            `Parent product ${cleanParentHandle} not found, using original product for recommendations`
          );
        }
      }
      const relatedProductsMetafield = (_b = productData.metafields) == null ? void 0 : _b.find(
        (metafield) => metafield.namespace === "shopify--discovery--product_recommendation" && metafield.key === "related_products"
      );
      const cartUpsellMetafield = (_c = productData.metafields) == null ? void 0 : _c.find(
        (metafield) => metafield.namespace === "brewdog" && metafield.key === "cart_upsell_products"
      );
      const selectedMetafield = cartUpsellMetafield || relatedProductsMetafield;
      if (!(selectedMetafield == null ? void 0 : selectedMetafield.value)) {
        return null;
      }
      let relatedProductIds;
      try {
        relatedProductIds = JSON.parse(selectedMetafield.value);
      } catch (e) {
        relatedProductIds = selectedMetafield.value.split(",").map((id) => id.trim());
      }
      if (!(relatedProductIds == null ? void 0 : relatedProductIds.length)) {
        return null;
      }
      const productPromises = relatedProductIds.map(
        async (productId) => {
          if (productId.includes("gid://") || /^\d+$/.test(productId)) {
            const numericId = productId.replace(/\D/g, "");
            const productResponse = await fetch(`/products/${numericId}.js`);
            if (!productResponse.ok) {
              return null;
            }
            return await productResponse.json();
          } else {
            const productResponse = await fetch(`/products/${productId}.js`);
            if (!productResponse.ok) {
              return null;
            }
            return await productResponse.json();
          }
        }
      );
      const products = await Promise.all(productPromises);
      const validProducts = products.filter((product) => product !== null);
      if (validProducts.length === 0) {
        return null;
      }
      const filteredProducts = validProducts.filter(
        (product) => product.available && product.title !== "Pfand" && !this.isProductSeoHidden(product) && !this.isPersonalisedProduct(product)
      ).slice(0, this.recommendationsCount);
      return filteredProducts;
    } catch (error) {
      console.error("Error fetching metafield related products:", error);
      return null;
    }
  }
  /**
   * Fall back to recommendations API
   */
  async fetchRecommendationsAPI() {
    const productRecommendationsUrl = window.themeVars.routes.product_recommendations_url;
    if (!this.recommendationProductHandle)
      return;
    try {
      const productResponse = await fetch(
        `/products/${this.recommendationProductHandle}.js`
      );
      if (!productResponse.ok) {
        console.error("Could not fetch product for recommendations API");
        this.hideUpsell();
        return;
      }
      const productData = await productResponse.json();
      const productId = productData.id;
      const url = `${productRecommendationsUrl}.json?product_id=${productId}&limit=20&intent=${this.recommendationsType}`;
      const response = await fetch(url);
      const data = await response.json();
      const limitProducts = data.products.filter(
        (product) => product.available && product.title !== "Pfand" && !this.isProductSeoHidden(product) && !this.isPersonalisedProduct(product)
      ).slice(0, this.recommendationsCount);
      this.recommendations = limitProducts;
      const showUpsell = this.recommendations && this.recommendations.length > 0;
      showUpsell ? this.showUpsell() : this.hideUpsell();
    } catch (e) {
      console.error("Fetch error:", e);
      this.hideUpsell();
    }
  }
  /**
   * Check if a product should be hidden based on seo-hidden tag or metafield
   */
  isProductSeoHidden(product) {
    if (product.tags && product.tags.includes("seo-hidden")) {
      return true;
    }
    if (product.seoHidden === true || product.seoHidden === "1") {
      return true;
    }
    return false;
  }
  isPersonalisedProduct(product) {
    if (!Array.isArray(product.tags)) {
      return false;
    }
    return product.tags.includes("personalised");
  }
  get recommendations() {
    return this._recommendations;
  }
  set recommendations(value) {
    this._recommendations = value;
    this.renderRecommendations();
  }
  renderRecommendations() {
    if (!this.productWrapper || !this._recommendations)
      return;
    this.productWrapper.innerHTML = "";
    const noBundleRecs = this._recommendations.filter(
      (product) => product.type !== "Bundle"
    );
    const cartUpsellTitle = document.querySelector(".cart-upsell__title");
    if (noBundleRecs.length === 0 && cartUpsellTitle) {
      cartUpsellTitle.style.display = "none";
    }
    noBundleRecs.forEach((product) => {
      var _a, _b;
      const firstAvailableVariant = product == null ? void 0 : product.variants.find(
        (variant) => variant.available
      );
      if (!firstAvailableVariant)
        return;
      const priceHtml = this.getPriceHtml(
        firstAvailableVariant.price,
        firstAvailableVariant.compare_at_price
      );
      const productHtml = `
        <div class="cart-upsell__product">
          <img
            src="${product.images[0]}"
            alt="${product.title}"
            class="cart-upsell__product-image"
            width="80"
            height="80"
          />

          <div class="
            cart-upsell__product-image
            cart-upsell__product-image--placeholder
          "></div>

          <div class="cart-upsell__product-details">
            <p class="
              cart-upsell__product-title
              heading-4
            ">
              ${product.title}
            </p>

            <p class="
              cart-upsell__product-option
              text-md-body
              ${firstAvailableVariant.title === "Default Title" ? "is-hidden" : ""}
            ">
              ${firstAvailableVariant.title}
            </p>

            <div class="cart-upsell__product-price">
              ${priceHtml}
            </div>
          </div>

          <button
            class="cart-upsell__product-cta"
            data-variant-id="${firstAvailableVariant.id}"
            js-cart-upsell="cta"
          >
            ${window.themeVars.icons.addToCart}
          </button>
        </div>
      `;
      (_a = this.productWrapper) == null ? void 0 : _a.insertAdjacentHTML("beforeend", productHtml);
      const ctaButton = (_b = this.productWrapper) == null ? void 0 : _b.querySelector(
        `[data-variant-id="${firstAvailableVariant.id}"]`
      );
      ctaButton == null ? void 0 : ctaButton.addEventListener("click", () => {
        this.addItem(firstAvailableVariant.id);
      });
    });
  }
  getPriceHtml(price, compareAtPrice) {
    const formattedPrice = formatMoney(price);
    const formattedCompareAtPrice = formatMoney(compareAtPrice);
    if (Number(compareAtPrice) > Number(price)) {
      return `
        <div class="main-cart__price-wrapper">
          <div class="price__sale">
            <span class="visually-hidden">
              ${window.themeVars.strings.product.price.sale}
            </span>

            <span class="price__item price__item--sale price__item--last text-md-body--semi-bold">
              ${formattedPrice}
            </span>

            <span class="visually-hidden">
              ${window.themeVars.strings.product.price.sale}
            </span>

            <span class="price__item price__item--regular">
              ${formattedCompareAtPrice}
            </span>
          </div>
        </div>
      `;
    }
    return `
      <div class="main-cart__price-wrapper">
        <div class="price__regular">
          <span class="visually-hidden">
            ${window.themeVars.strings.product.price.regular}
          </span>

          <span class="price__item price__item--regular text-md-body--semi-bold">
            ${formattedPrice}
          </span>
        </div>
      </div>
    `;
  }
  addItem(itemId) {
    super.addItem(itemId);
  }
  showUpsell() {
    this.classList.remove("is-hidden");
  }
  hideUpsell() {
    this.classList.add("is-hidden");
  }
}
customElements.define("uwp-cart-upsell", CartUpsell);
